/**
 * 发运总览看板 — produce POST /api/produce/kanban/shipment-overview
 * 与 axios 默认 baseURL（/produce）组合为 /produce/api/produce/kanban/shipment-overview
 */
import request from '@/router/axios'

const API = '/api/produce/kanban/shipment-overview'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchShipmentOverview(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
